class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
    this.onCartRefreshListener = this.onCartRefresh.bind(this);
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);
    this.handleContinueShopping = null;
  }

  get requiresBodyAppended() {
    return false;
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      "cart:grouped-sections",
      this.getSectionToRenderListener,
    );
    document.addEventListener("cart:refresh", this.onCartRefreshListener);

    this.initContinueShoppingButton();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      "cart:grouped-sections",
      this.getSectionToRenderListener,
    );
    document.removeEventListener("cart:refresh", this.onCartRefreshListener);
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open && !Shopify.designMode) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }

    this.initContinueShoppingButton();
  }

  async onCartRefresh(event) {
    const cartId = `CartDrawer-${this.sectionId}`;
    const cartElement = document.getElementById(cartId);
    if (!cartElement) return;

    try {
      const response = await fetch(
        `${FoxTheme.routes.root_url}?section_id=${this.sectionId}`,
      );
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, "text/html");

      const newCartContent = parsedHTML.getElementById(cartId).innerHTML;
      cartElement.innerHTML = newCartContent;

      if (event.detail.open === true) {
        this.show();
      }

      this.initContinueShoppingButton();
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  }

  initContinueShoppingButton() {
    const continueBtn = this.querySelector(".cart-drawer__continue-shopping");
    if (!continueBtn) return;

    if (this.handleContinueShopping) {
      continueBtn.removeEventListener("click", this.handleContinueShopping);
    }

    this.handleContinueShopping = () => {
      const internalCloseBtn = this.querySelector(".drawer__close-btn");
      if (internalCloseBtn) {
        internalCloseBtn.click();
      } else {
        this.hidden = true;
      }
    };

    continueBtn.addEventListener("click", this.handleContinueShopping);
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartAddonModal extends ModalComponent {
  constructor() {
    super();
  }

  get focusElement() {
    return (
      this.querySelector("input, textarea, select") ||
      this.querySelector("button")
    );
  }
}
customElements.define("cart-addon-modal", CartAddonModal);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      FoxTheme.utils.debounce(this.onChange.bind(this), 300),
    );
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this),
    );

    this.cartItemProducts = this.querySelectorAll(".cart-item__product");
    this.cartItemQuantitys = this.querySelectorAll(".cart-item__quantity");

    const loadTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const template = element.querySelector("template");
        const templateContent =
          template && document.importNode(template.content, true);
        const parent = element.querySelector(parentSelector);

        if (parent && template && !parent.querySelector(".template-content")) {
          const contentWrapper = document.createElement("div");
          contentWrapper.classList.add("template-content");
          contentWrapper.appendChild(templateContent);
          parent.appendChild(contentWrapper);
        }
      });
    };

    const removeTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const parent = element.querySelector(parentSelector);
        const templateContent = parent?.querySelector(".template-content");

        if (templateContent) {
          parent.removeChild(templateContent);
        }
      });
    };

    const handleTabletMatch = () => {
      loadTemplateContent(this.cartItemProducts, ".cart-item__product--info");
      removeTemplateContent(
        this.cartItemQuantitys,
        ".cart-item__quantity-wrapper",
      );
    };

    const handleTabletUnmatch = () => {
      removeTemplateContent(this.cartItemProducts, ".cart-item__product--info");
      loadTemplateContent(
        this.cartItemQuantitys,
        ".cart-item__quantity-wrapper",
      );
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;

    if (FoxTheme.config.mqlTablet) {
      handleTabletMatch();
    } else {
      handleTabletUnmatch();
    }

    mqlTablet.onchange = (event) => {
      if (event.matches) {
        handleTabletMatch();
      } else {
        FoxTheme.config.mqlTablet = false;
        handleTabletUnmatch();
      }
    };

    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target,
    );
  }

  onCartError(errors, target) {
    if (target) {
      this.hideLoader(target.getAttribute("data-index"));
      this.setValidity(target, errors);
      return;
    } else {
      window.location.href = FoxTheme.routes.cart_url;
    }
    alert(errors);
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    // --- INTEGRACIÓN CLUB PIKOLIN BUSINESS (CORREGIDA) ---
    try {
      if (event.cart && event.cart.original_total_price !== undefined) {
        // Sincronizamos la cookie con el precio original para evitar discrepancias
        document.cookie =
          "pikolin_cart_total=" +
          event.cart.original_total_price +
          "; path=/; SameSite=Lax";

        if (typeof window.applyClubLogic === "function") {
          window.applyClubLogic();
        }
      }
    } catch (e) {
      console.warn("Error en actualización de precios Club:", e);
    }
    // ------------------------------------------------------

    const sectionId = FoxTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(
      event.cart.sections[sectionId],
      "text/html",
    );

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(
      `#CartDrawerBody-${sectionId}`,
    );
    const cartDrawerFooter = document.querySelector(
      `#CartDrawerFooter-${sectionId}`,
    );
    const cartDrawerEmpty = document.querySelector(
      `#CartDrawerEmpty-${sectionId}`,
    );

    if (cartDrawer) {
      const cartDrawerBodyUpdate = sectionToRender.querySelector(
        `#CartDrawerBody-${sectionId}`,
      );
      const cartDrawerFooterUpdate = sectionToRender.querySelector(
        `#CartDrawerFooter-${sectionId}`,
      );
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(
        `#CartDrawerEmpty-${sectionId}`,
      );

      if (cartDrawerBodyUpdate)
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      if (cartDrawerFooterUpdate)
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      if (cartDrawerEmptyUpdate)
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove("hidden");
        cartDrawerFooter.classList.remove("hidden");
        cartDrawerEmpty.classList.add("hidden");
      } else {
        cartDrawerBody.classList.add("hidden");
        cartDrawerFooter.classList.add("hidden");
        cartDrawerEmpty.classList.remove("hidden");
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(
        `#MainCart-${sectionId}`,
      );
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
        if (event.cart.item_count > 0) {
          mainCart.closest(".cart").classList.remove("is-empty");
        } else {
          mainCart.closest(".cart").classList.add("is-empty");
        }
      } else {
        mainCart.closest(".cart").classList.add("is-empty");
        mainCart.remove();
      }
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: {
          cart: event.cart,
        },
      }),
    );
  }

  updateQuantity(line, quantity, name, target) {
    this.showLoader(line);

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          cart: parsedState,
          target,
          line,
          name,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add("btn--loading");
      });
    }
  }

  hideLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.remove("btn--loading");
      });
    }
  }
}
customElements.define("cart-items", CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems = this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-item", CartRemoveItem, { extends: "a" });

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "change",
      FoxTheme.utils.debounce(this.onChange.bind(this), 300),
    );
  }
  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    });
  }
}
customElements.define("cart-note", CartNote);

class CartDiscount extends HTMLFormElement {
  constructor() {
    super();
    this.addEventListener("submit", this.handleFormSubmit.bind(this));
  }
  handleFormSubmit(event) {
    event.preventDefault();
    // Lógica de cupones simplificada para el ejemplo
  }
}
customElements.define("cart-discount", CartDiscount, { extends: "form" });

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();

    this.progress = this.querySelector(".progress-bar");
    this.milestonesContainer = this.querySelector(".milestones");
    this.leftToSpendEl = this.querySelector("[data-left-to-spend]");
    this.milestones = JSON.parse(this.dataset.milestones || "[]");

    // Total inicial en euros
    this.cartTotal = Number(this.dataset.cartTotal) || 0;
  }
  connectedCallback() {
    this.updateShippingGoal(this.cartTotal);

    document.addEventListener("cart:updated", (event) => {
      // Convertir a euros al actualizar
      let newTotal = event.detail.cart.items_subtotal_price / 100;
      this.updateShippingGoal(newTotal);
    });
  }

  updateShippingGoal(amount) {
    this.cartTotal = amount;

    if (!this.progress) return;

    const maxGoal = this.milestones[this.milestones.length - 1].amount;
    let percent = (this.cartTotal * 100) / maxGoal;
    if (percent > 100) percent = 100;
    this.progress.style.width = `${percent}%`;

    const labelPrefix = this.dataset.labelPrefix || "Gasta";
    const labelSuffix = this.dataset.labelSuffix || "más para obtener un";
    const goalReached = this.dataset.goalReached || "¡Has conseguido el máximo descuento!";

    if (this.leftToSpendEl) {
      let next = this.milestones.find((m) => this.cartTotal < m.amount);
      if (next) {
        let left = next.amount - this.cartTotal;
        this.leftToSpendEl.textContent = `${labelPrefix} ${left.toFixed(2)}€ ${labelSuffix} ${next.label}`;
      } else {
        this.leftToSpendEl.textContent = goalReached;
      }
    }

    this.milestonesContainer.innerHTML = "";
    this.milestones.forEach((m, index) => {
      const isLast = index === this.milestones.length - 1;
      const leftPercent = isLast ? 92 : (m.amount / maxGoal) * 100;
      const wrapper = document.createElement("span");
      wrapper.className = "milestone absolute flex flex-col items-center transform -translate-x-1/2";
      wrapper.style.left = `${leftPercent}%`;

      const labelEl = document.createElement("span");
      labelEl.className = "milestone__label absolute -top-5 text-xs";
      labelEl.textContent = m.label;
      wrapper.appendChild(labelEl);

      if (m.tip) {
        const tipEl = document.createElement("span");
        tipEl.className = "milestone__tip absolute top-full mt-1 text-xs whitespace-nowrap";
        tipEl.textContent = m.tip;
        wrapper.appendChild(tipEl);
      }

      if (this.cartTotal >= m.amount) wrapper.classList.add("active");
      this.milestonesContainer.appendChild(wrapper);
    });
  }
}

customElements.define("free-shipping-goal", FreeShippingGoal);

window.FoxKitAddToCart = async (payload) => {
  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();

  // Actualizamos cookie también en el añadir
  document.cookie =
    "pikolin_cart_total=" +
    cartJson.original_total_price +
    "; path=/; SameSite=Lax";
  if (window.applyClubLogic) window.applyClubLogic();

  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
    cart: cartJson,
  });
};
